import React, {  useMemo } from "react";
import "./Rim-metrics.css";
import PropTypes from "prop-types";
function RimMicroOptMetrics({ legends }) {
 

  const RimrenderMetrics = useMemo(() => {
    const renderMetric = (legend, index) => {
 
   

      return (
        <div id="rim-metrics" key={index}>
          <span className="Rim-metric-name">{legend.metricName}</span>
          <div id="Rim-metrics-details">
            <span className="Rim-metric-score">
              {legend.metricScore}
            
            </span>
          </div>
        </div>
      );
    };

    return legends?.map((legend, index) => renderMetric(legend, index));
  }, [legends]);

  return (
    <div className="Rim-metrics-box" style={{ backgroundColor: "white", position: "relative" }}>
      {RimrenderMetrics}
    </div>
  );
}



// ✅ Props validation added to remove S6774
RimMicroOptMetrics.propTypes = {
  legends: PropTypes.arrayOf(
    PropTypes.shape({
      metricName: PropTypes.string,
      metricScore: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
};

export default RimMicroOptMetrics;